import { defineStore } from 'pinia'

export const useModalStore = defineStore('modal', {
  state: () => ({
    visible: false,
    title: '',
    message: '',
    confirmText: '확인',
    cancelText: '취소',
    onConfirm: null, // 타입 지정 제거
    onCancel: null,
  }),
  actions: {
    open({ title, message, confirmText = '확인', cancelText = '취소', onConfirm, onCancel }) {
      this.title = title
      this.message = message
      this.confirmText = confirmText
      this.cancelText = cancelText
      this.onConfirm = onConfirm
      this.onCancel = onCancel
      this.visible = true
    },
    close() {
      this.visible = false
    },
  },
})
